// function handleQtyValidation(e) {
//   const target = e.target;

//   if (target.matches("input.cart__qty-input, input.product-form__input--quantity")) {
//     const min = parseInt(target.min) || 0;
//     const newValue = parseInt(target.value);

//     if (newValue < min) {
//       target.value = min;
//       e.stopImmediatePropagation();
//     }
//   }
// }

// document.addEventListener("change", handleQtyValidation, true);

document.addEventListener("DOMContentLoaded", () => {
	const checkoutButton = document.querySelector(".cart__submit.OTCheckout");
	if (checkoutButton.disabled) {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (
					mutation.type === 'attributes' &&
					mutation.attributeName === 'disabled' &&
					!checkoutButton.disabled
				) {
					checkoutButton.disabled = true;
				}
			});
		});

		observer.observe(checkoutButton, {
			attributes: true,
			attributeFilter: ['disabled'],
		});
	}
});